/*
 * Copyright (c) 2023 Powerledger Pty Ltd. All Rights Reserved.
 */

import { Button, Flex, LegacyCheckbox, Text } from "@powerledger/ui-component-lib";
import { useField } from "formik";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useTranslatedFile } from "@/app/hooks";

import { LegalDocumentModal } from "../LegalDocumentModal";

export const LegalCheckBox = ({
  id,
  name,
  title,
  handleAcknowledgementChange,
  translatedFileKey,
  disabled,
  downloadUrl,
}: {
  id: string;
  name: string;
  title: string;
  handleAcknowledgementChange: (name: string) => void;
  translatedFileKey: string;
  downloadUrl: string | undefined;
  disabled?: boolean;
}) => {
  const { t } = useTranslation();
  const [field] = useField({ name: name, type: "checkbox" });

  const [showLegalDocumentModal, setShowLegalDocumentModal] = useState(false);
  const { loading: loadingTranslatedFile, file } = useTranslatedFile("translation", translatedFileKey);

  return (
    <>
      <LegacyCheckbox
        id={id}
        {...field}
        onChange={() => handleAcknowledgementChange(name)}
        disabled={disabled}
        label={
          <Flex sx={{ alignItems: "center", flexShrink: 0 }}>
            <Text>{t("I accept")}</Text>
            &nbsp;
            <Button
              type="button"
              variant="text"
              sx={{
                textDecoration: "underline",
                fontFamily: "inter",
                textAlign: "left",
              }}
              onClick={() => setShowLegalDocumentModal(true)}
            >
              {t(title)}
            </Button>
          </Flex>
        }
      />
      <LegalDocumentModal
        visible={showLegalDocumentModal}
        content={loadingTranslatedFile ? undefined : file}
        closeModal={() => setShowLegalDocumentModal(false)}
        download={downloadUrl}
        {...(!disabled &&
          !field.value && {
            accept: () => {
              handleAcknowledgementChange(name);
              setShowLegalDocumentModal(false);
            },
          })}
      />
    </>
  );
};
